module.exports = __webpack_public_path__ + "img/course.f1094c38.png";